import Vue from 'vue';
import VueRouter from 'vue-router';

import { AuthenticationContext } from './authentication-context';
import { MsalConfig } from './msal-config';

let authenticationContext = null;

const MsalPlugin = {
  install(vue: typeof Vue, opts: { config: MsalConfig; router: VueRouter }) {
    authenticationContext = new AuthenticationContext(opts.config, opts.router);

    vue.prototype.$authContext = authenticationContext;

    vue.mixin({
      computed: {
        auth() {
          return {
            isAuthenticated: (this.$authContext as any)._oauthData.isAuthenticated,
            user: (this.$authContext as any).getAccount(),
            context: this.$authContext
          };
        }
      }
    });
  }
};

export default MsalPlugin;
